export default __webpack_public_path__ + "static/media/shatz10.06e93fac.jpg";